import './Choose.css';
/* src/Choose.svelte generated by Svelte v3.23.0 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	space,
	text,
	toggle_class
} from "/web_modules/svelte/internal.js";

function create_fragment(ctx) {
	let form;
	let h2;
	let t1;
	let p0;
	let t3;
	let p1;
	let t5;
	let p2;
	let t7;
	let div;
	let button0;
	let t9;
	let button1;
	let t10;
	let button1_disabled_value;
	let t11;
	let input;
	let mounted;
	let dispose;

	return {
		c() {
			form = element("form");
			h2 = element("h2");
			h2.textContent = "Choose files to load";
			t1 = space();
			p0 = element("p");
			p0.textContent = "Open mbox files, or load individual emails. You can add multiple files.";
			t3 = space();
			p1 = element("p");
			p1.textContent = "Your email is processed in your web browser. Your data never leaves your computer.";
			t5 = space();
			p2 = element("p");
			p2.innerHTML = `<a href="https://github.com/josephg/mbox-viewer/blob/master/README.md">Please file issues here if you run into problems!</a>`;
			t7 = space();
			div = element("div");
			button0 = element("button");
			button0.textContent = "1. Select files (eml or mbox)";
			t9 = space();
			button1 = element("button");
			t10 = text("2. Open 'er up!");
			t11 = space();
			input = element("input");
			attr(h2, "class", "svelte-vkym6h");
			attr(p0, "class", "svelte-vkym6h");
			attr(p1, "class", "svelte-vkym6h");
			attr(p2, "class", "svelte-vkym6h");
			attr(button0, "class", "svelte-vkym6h");
			toggle_class(button0, "softDisable", /*files*/ ctx[0] != null);
			button1.disabled = button1_disabled_value = /*files*/ ctx[0] == null;
			attr(button1, "class", "svelte-vkym6h");
			attr(input, "type", "file");
			attr(input, "id", "mboxfile");
			attr(input, "accept", ".mbox,.eml,.msg,.txt,application/mbox,message/rfc822");
			input.multiple = true;
			attr(input, "class", "svelte-vkym6h");
			attr(form, "id", "choose");
			attr(form, "class", "svelte-vkym6h");
		},
		m(target, anchor) {
			insert(target, form, anchor);
			append(form, h2);
			append(form, t1);
			append(form, p0);
			append(form, t3);
			append(form, p1);
			append(form, t5);
			append(form, p2);
			append(form, t7);
			append(form, div);
			append(div, button0);
			append(div, t9);
			append(div, button1);
			append(button1, t10);
			append(div, t11);
			append(div, input);
			/*input_binding*/ ctx[5](input);

			if (!mounted) {
				dispose = [
					listen(button0, "click", /*click_handler*/ ctx[4]),
					listen(input, "change", /*input_change_handler*/ ctx[6]),
					listen(form, "submit", /*submit*/ ctx[2])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*files*/ 1) {
				toggle_class(button0, "softDisable", /*files*/ ctx[0] != null);
			}

			if (dirty & /*files*/ 1 && button1_disabled_value !== (button1_disabled_value = /*files*/ ctx[0] == null)) {
				button1.disabled = button1_disabled_value;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(form);
			/*input_binding*/ ctx[5](null);
			mounted = false;
			run_all(dispose);
		}
	};
}

let gotFile = false;

function instance($$self, $$props, $$invalidate) {
	let files = null;
	let { process } = $$props;
	let filePicker;

	// function onFileSet(e) {
	//   console.log('got file')
	//   gotFile = true
	//   console.log('file', file)
	// }
	function submit(e) {
		console.log("submit");
		e.preventDefault();

		// state = 'processing'
		process(files);
	}

	const click_handler = e => {
		filePicker.click();
		e.preventDefault();
	};

	function input_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			$$invalidate(1, filePicker = $$value);
		});
	}

	function input_change_handler() {
		files = this.files;
		$$invalidate(0, files);
	}

	$$self.$set = $$props => {
		if ("process" in $$props) $$invalidate(3, process = $$props.process);
	};

	return [
		files,
		filePicker,
		submit,
		process,
		click_handler,
		input_binding,
		input_change_handler
	];
}

class Choose extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { process: 3 });
	}
}

export default Choose;